import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://nkfaurnrivoqvumhaczb.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5rZmF1cm5yaXZvcXZ1bWhhY3piIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk4OTE1MjAsImV4cCI6MjA5NTQ2NzUyMH0.zmMOFmHfOYZnVKaPvkoceHkSRZKs9bfUYIeb3ZShWIU';

export const supabase = createClient(supabaseUrl, supabaseKey);
